import * as React from "react";
import { ErrorBoundary as ErrorBoundary$1 } from "@grandvisionhq/common";
import { isAppointmentErrorStatus } from "../../../../../utils/v3/utils/appointments.js";
import AppointmentErrorContainer from "../../../../AppointmentError/v3/components/AppointmentError/AppointmentErrorContainer.js";
const ErrorBoundary = ({
  bookAppointmentUrl,
  children
}) => /* @__PURE__ */ React.createElement(ErrorBoundary$1, null, (error) => error ? /* @__PURE__ */ React.createElement(
  AppointmentErrorContainer,
  {
    bookAppointmentUrl,
    status: isAppointmentErrorStatus(error.message) ? error.message : "INTERNAL_SERVER_ERROR"
  }
) : children);
export {
  ErrorBoundary as default
};
//# sourceMappingURL=ErrorBoundary.js.map
